import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { LazyLoadEvent } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { DefaultService } from 'src/app/core/framework/default-service';
import { DefaultFilter } from 'src/app/core/framework/default-service.interface';
import { IListaBundle } from 'src/app/core/list/lista-bundle.interface';
import { ListaPaginacao } from 'src/app/core/list/lista-paginacao.interface';
import { ListaComponent } from 'src/app/core/list/lista.component';
import { ILista } from 'src/app/core/list/lista.interface';
import { Metadata } from 'src/app/core/list/metadata/metadata.component';
import { CfgIntegracaoEvento } from '../../../model/cfg-integracao-evento.model';
import { CfgIntegracaoEventoLogService } from '../service/cfg-integracao-evento-log.service';
import { CfgIntegracaoEventoService } from '../service/cfg-integracao-evento.service';
import { CfgIntegracaoEventoLogFilter } from './model/cfg-integracao-evento-log.filter';
import { CfgIntegracaoEventoLogMetadata } from './model/cfg-integracao-evento-log.metadata';
import { CfgIntegracaoEventoLog } from './model/cfg-integracao-evento-log.model';


@Component({
  selector: 'app-cfg-integracao-evento-log',
  templateUrl: './cfg-integracao-evento-log.component.html',
  styleUrls: ['./cfg-integracao-evento-log.component.css']
})
export class CfgIntegracaoEventoLogComponent implements OnInit, ILista {

  filter: CfgIntegracaoEventoLogFilter;

  @ViewChild('lista') private listaComponent: ListaComponent;
  
  exibindoLogDeVariosEventos = false;
  listaDeIdsCfgIntegracaoEvento: string;
  idAssinaturaDigitalEvento: number;

  constructor(
    private cfgIntegracaoEventoLogService: CfgIntegracaoEventoLogService
    , private cfgIntegracaoEventoService: CfgIntegracaoEventoService
    , private activatedRoute: ActivatedRoute
    , private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService
        .getOrCreateMenuConfig()
        .hideAll()
        .setShowVoltar(true);

    this.activatedRoute
        .params
        .pipe(
          map(params => {
            let idCfgIntegracaoEvento = params['id'];

            this.filter = {};

            // Filtro por Evento
            if ( idCfgIntegracaoEvento?.indexOf(',') > 0 ) {
              this.exibindoLogDeVariosEventos = true;
              this.listaDeIdsCfgIntegracaoEvento = params['id'];
              idCfgIntegracaoEvento = params['id'].split(',')[0];
            }

            if ( idCfgIntegracaoEvento ) {
              this.filter.idCfgIntegracaoEvento = Number.parseInt(idCfgIntegracaoEvento);
            }

            // Filtro por Id Assinatura Digital Evento
            if ( params['idAssinaturaDigitalEvento'] ) {
              this.filter.idAssinaturaDigitalEvento = Number.parseInt(params['idAssinaturaDigitalEvento']);
              this.idAssinaturaDigitalEvento = this.filter.idAssinaturaDigitalEvento;
            }
            
            return idCfgIntegracaoEvento;
          })
          , switchMap((idCfgIntegracaoEvento: number) => {
            if ( idCfgIntegracaoEvento ) {
              this.cfgIntegracaoEventoService
                  .fetch(idCfgIntegracaoEvento)
                  .subscribe((cfgIntegracaoEvento: CfgIntegracaoEvento) => {
                    this.breadcrumbService.setItems([
                      {label: 'Segurança'}, { label: 'Configuração' }, { label: 'Integração de APIs' }, { label: 'Log: ' + cfgIntegracaoEvento.nome }
                    ])
                  })
            }
            
            return of([]);
          })
        )
        .subscribe();
  }  

  aoMudarPagina?(event: LazyLoadEvent): Observable<ListaPaginacao> {
    throw new Error('Method not implemented.');
  }

  aoSelecionarLinha(e: IListaBundle, dataKey: any): void {
    throw new Error('Method not implemented.');
  }

  getService(): DefaultService<CfgIntegracaoEventoLog> {
    return this.cfgIntegracaoEventoLogService;
  }

  getMetadata(): Metadata[] {
    return CfgIntegracaoEventoLogMetadata.getMetadata(this.exibindoLogDeVariosEventos);
  }

  getFilter(): DefaultFilter {
    this.filter.sort = ['dataAlteracao,desc'];
    if ( this.exibindoLogDeVariosEventos ) {
      this.filter.idsCfgIntegracaoEvento = this.listaDeIdsCfgIntegracaoEvento;
    }
    
    return this.filter;
  }

}
